import { render, staticRenderFns } from "./BonusContentAdd.vue?vue&type=template&id=529d11ac"
import script from "./BonusContentAdd.vue?vue&type=script&lang=js"
export * from "./BonusContentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports